import { Link } from 'react-router-dom';

const RefreshButton = () => {
  return (
    <Link role="button" className="btn" to="/">
      Fix it!
    </Link>
  );
};

export default RefreshButton;
